import { Heart } from 'lucide-react';

/* ═══════════════════════════════════════════
   EDITABLE: Footer content
═══════════════════════════════════════════ */
const COMPANY_NAME = 'Ashwamedh';
const COMPANY_DESC = 'Financial Services since 1991. Your trusted partner for Insurance, Mutual Funds, Taxation, and comprehensive financial planning in Mumbai.';
const PHONE = '+91 9870281491';
const EMAIL = 'ashwamedh360@gmail.com';
const ADDRESS = 'Vastu Central, J.K. Sawant Marg, Near BMC Parking, Dadar West, Mumbai - 400028';

const quickLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Products', href: '#products' },
  { label: 'Achievements', href: '#achievements' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'Contact', href: '#contact' },
];

const services = [
  'Mutual Funds',
  'Insurance',
  'Tax Planning',
  'Portfolio Management',
  'Retirement Planning',
  'Succession Planning',
];

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#0A192F] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_financial-evolution-1/artifacts/o920clpu_Ashwamedh%20Logo%20-%201.png"
              alt="Ashwamedh 360"
              className="h-20 w-auto object-contain mb-4"
            />
            <p className="text-sm text-white/50 leading-relaxed font-['Outfit']">
              {COMPANY_DESC}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-[#D4AF37] mb-4">
              Quick Links
            </h4>
            <nav className="space-y-2">
              {quickLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="block text-sm text-white/60 hover:text-[#D4AF37] transition-colors font-['Outfit']"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-[#D4AF37] mb-4">
              Our Services
            </h4>
            <nav className="space-y-2">
              {services.map((service) => (
                <span key={service} className="block text-sm text-white/60 font-['Outfit']">
                  {service}
                </span>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-[#D4AF37] mb-4">
              Office
            </h4>
            <p className="text-sm text-white/50 leading-relaxed mb-3 font-['Outfit']">
              {ADDRESS}
            </p>
            <p className="text-sm text-white/50 font-['Outfit']">{EMAIL}</p>
            <p className="text-sm text-white/50 font-['Outfit']">{PHONE}</p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40 font-['Outfit']">
            &copy; {new Date().getFullYear()} {COMPANY_NAME} Financial Services. All rights reserved.
          </p>
          <p className="text-xs text-white/40 flex items-center gap-1 font-['Outfit']">
            Made with <Heart size={12} className="text-[#D4AF37]" /> in Mumbai
          </p>
        </div>
      </div>
    </footer>
  );
};
